<script setup lang="ts">
import { computed, defineEmits, defineProps, ref } from "vue";
import { useOperationStore } from "@/stores/operation";
import { getFileData } from "@/libs/tools";
import StoreMapper from "@/components/forms/StoreMapperView.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Teleport from "vue2-teleport";

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const custom = computed(() => operationStore.customData);
const files = op.value?.files;

const rules = computed(() => {
  return files ? getFileData(files, "reglement") : null;
});

const externallinks = ref<string | null>(null);
const store_visible = ref(false);

const politique = computed(() => {
  return files ? getFileData(files, "politique") : null;
});

const emit = defineEmits(["path", "externallink"]);

const setPath = (path: string) => {
  emit("path", path);
  store_visible.value = false;
  externallinks.value = null;
};

const openLink = (link: { link: string; link_type: string }) => {
  if (link.link_type == "outside") {
    window.open(link.link, "_blank");
  }
  if (link.link_type == "inside") {
    store_visible.value = false;
    externallinks.value = link.link;
    emit("externallink", link.link);
  }
};

const openStore = () => {
  store_visible.value = true;
};

// eslint-disable-next-line no-undef
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  overquota: {
    type: Boolean,
    default: false,
  },
});

const links = ref<{ label: string; link: string; link_type: string }[]>(
  custom.value?.links ?? []
);
</script>
<template>
  <div id="menu">
    <div class="menu_wrapper" />
    <Teleport to="#gab">
      <div
        v-if="store_visible"
        class="absolute inset-0 bg-primary-bg overflow-auto w-full h-full z-50"
      >
        <StoreMapper :id="custom?.storemapper_id" />
      </div>
    </Teleport>

    <ul class="flex justify-between px-4 items-center w-full">
      <li>
        <a href="https://www.pacificetgeneral.com/" target="_blank"
          ><img src="/pacific-blanc.png" class="w-28 ml-2"
        /></a>
      </li>
      <li class="flex-1 text-center">
        <ul class="nav justify-center gap-4 text-center">
          <li @click="setPath('login')"><i class="fa-solid fa-house"></i></li>
          <li
            v-if="props.status === 'open' && !props.overquota"
            @click="setPath('register')"
          >
            {{ $t("header.register_link") }}
          </li>
          <li>|</li>

          <li v-if="custom?.storemapper_id">
            <a @click="openStore()">Distributeurs participants</a>
          </li>
          <li>|</li>
          <li v-if="links && links[0].label">
            <a @click="() => openLink(links[0])" v-html="links[0].label" />
          </li>
          <li>|</li>
          <li v-if="links && links[1].label">
            <a @click="() => openLink(links[1])" v-html="links[1].label" />
          </li>
          <li>|</li>
          <li @click="setPath('contact')">{{ $t("header.contact_link") }}</li>
        </ul>
      </li>
      <li>
        <ul class="justify-end gap-3 text-[1.2em]">
          <li v-if="custom?.facebook_link">
            <a :href="custom?.facebook_link" target="_blank"
              ><i class="fa-brands fa-facebook"></i
            ></a>
          </li>
          <li v-if="custom?.instagram_link">
            <a :href="custom?.instagram_link" target="_blank"
              ><i class="fa-brands fa-instagram"></i
            ></a>
          </li>
          <li v-if="custom?.youtube_link">
            <a :href="custom?.youtube_link" target="_blank"
              ><i class="fa-brands fa-youtube"></i
            ></a>
          </li>
          <li v-if="custom?.linkedin_link">
            <a :href="custom?.linkedin_link" target="_blank"
              ><i class="fa-brands fa-linkedin"></i
            ></a>
          </li>
          <li v-if="custom?.pinterest_link">
            <a :href="custom?.pinterest_link" target="_blank"
              ><i class="fa-brands fa-pinterest"></i
            ></a>
          </li>
          <li v-if="custom?.snapchat_link">
            <a :href="custom?.snapchat_link" target="_blank"
              ><i class="fa-brands fa-snapchat"></i
            ></a>
          </li>
          <li v-if="custom?.twitter_link">
            <a :href="custom?.twitter_link" target="_blank"
              ><i class="fa-brands fa-x-twitter"></i
            ></a>
          </li>
          <li v-if="custom?.discord_link">
            <a :href="custom?.discord_link" target="_blank"
              ><i class="fa-brands fa-discord"></i
            ></a>
          </li>
          <li v-if="custom?.tiktok_link">
            <a :href="custom?.tiktok_link" target="_blank"
              ><i class="fa-brands fa-tiktok"></i
            ></a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
#menu {
  @apply inset-0 z-30 w-full h-[3.5vw] xl:h-12  justify-center items-center hidden desktop:flex relative text-[1em];
  border-top-right-radius: var(--border-radius-popup);
  border-top-left-radius: var(--border-radius-popup);
  a {
    @apply text-menu-links;
  }
  ul {
    @apply flex items-center relative z-20;
    li {
      @apply cursor-pointer text-menu-links;
    }
  }
}
.menu_wrapper {
  @apply bg-menu-bg backdrop-blur-0 opacity-[var(--menu-transparancy)] w-full h-full absolute inset-0 z-20;
  border-top-right-radius: var(--border-radius-popup);
  border-top-left-radius: var(--border-radius-popup);
}
</style>
